<template>
  <section class="menu">
    <span>热门目的地</span>
    <div class="pop" :class="{hide}">
      <ul class="nav">
        <li v-for="(v, i) in city" :key="v.pids" @mouseover.stop="cityIndex = i">
          <b>{{v.title}}</b>
          <p>
            <span v-for="s in v.hots" :key="s.id" @click="changeOption(s)">{{s.text}}</span>
          </p>
          <i class="icon-you"></i>
        </li>
      </ul>
      <ul class="option">
        <li>
          <b class="hot">热门</b>
          <p v-if="city[cityIndex]">
            <span @click="changeOption(s)" v-for="s in city[cityIndex].hots" :key="s.id">{{s.text}}</span>
          </p>
        </li>
        <template v-if="city[cityIndex]">
          <li v-for="v in city[cityIndex].children" :key="v.path">
            <b @click="changeOption(v)" style="cursor: pointer;">{{v.text}}</b>
            <p>
              <span v-for="s in v.children" :key="s.id" @click="changeOption(s)">{{s.text}}</span>
            </p>
          </li>
        </template>
      </ul>
    </div>
    
  </section>
</template>

<script>
import $tour from '@api/tour';
export default {
  data () {
    return {
      hide: false,
      cityIndex: 0,
      city: []
    }
  },
  async created () {
    const { TourDestinationV2: city } = await $tour.baseData();
    this.city = city;
  },
  methods: {
    changeOption (v) {
      const { level, path, children, id } = v;
      switch (level) {
        case 3: {
          const list = [{id: Number(id), text: '全部'}, ...children];
          this.$emit('change', { list, id });
          break;
        }
        case 4: {
          const [,,,level3ID] = path.split('-');
          const { pids, children } = this.city.find(v => v.pids.includes(level3ID));
          const i = pids.split(',').findIndex(v => v === level3ID);
          const list = [{ id: level3ID, text: '全部' }, ...children[i].children];
          this.$emit('change', { list, id });
          break;
        }
      }
      this.hide = true;
      setTimeout(() => this.hide = false, 500);
    }
  }
}
</script>

<style scoped src="./index.css"></style>